'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _ProcessingPage = require('../../../components/loaders/ProcessingPage');

var _ProcessingPage2 = _interopRequireDefault(_ProcessingPage);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var UnsubscribeProcessing = function UnsubscribeProcessing(props) {
    return _react2.default.createElement(
        _ProcessingPage2.default,
        null,
        _react2.default.createElement(
            'h1',
            null,
            'Processing'
        ),
        _react2.default.createElement(
            'p',
            null,
            'This should only take a few seconds\u2026'
        ),
        _react2.default.createElement(
            'p',
            { className: 'disclaimer' },
            _react2.default.createElement(
                'a',
                { href: 'mailto:support@milanote.com' },
                'Report a problem'
            )
        )
    );
};

exports.default = UnsubscribeProcessing;


//////////////////
// WEBPACK FOOTER
// ./src/client/user/account/unsubscribe/UnsubscribeProcessing.js
// module id = 2102
// module chunks = 0